import {
    Component,
    Input,
    ChangeDetectionStrategy,
    input,
} from '@angular/core';
import { InfoTooltipComponent } from '../../../../components/info-tooltip/info-tooltip.component';
import { EllipsisLoaderComponent } from '../ellipsis-loader/ellipsis-loader.component';
import { GenericTrendComponent } from '../generic-trend/generic-trend.component';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-generic-performance-metric',
    templateUrl: './generic-performance-metric.component.html',
    styleUrl: './generic-performance-metric.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        InfoTooltipComponent,
        EllipsisLoaderComponent,
        GenericTrendComponent,
        DecimalPipe,
    ],
})
export class GenericPerformanceMetricComponent {
    readonly currentKpi = input<number>(0);
    @Input() comparisonKpi: number | undefined;

    readonly percentChange = input<number>();

    readonly isLoading = input<boolean>(true);
    readonly showPrecision = input<boolean>(true);

    readonly metricName = input<string>('');
    readonly tooltipText = input<string>('');

    readonly inverted = input<boolean>(false);
    readonly timePeriod = input<number>(0);
    readonly unitOfMeasure = input<string>('');
    readonly genericTrendText = input<string>('network data');

    get percentChangedValue(): number {
        const percentChange = this.percentChange();
        if (percentChange) {
            return percentChange / 100;
        }

        return this.currentKpi() === 0 ? 0 : 1; // 100% change
    }
}
